export default __webpack_public_path__ + "static/luca-bravo-2-min-5106619ed0376cc47c41b455d271caff.jpg";